export var FLATTEN_CATEGORY = ['space', 'breakpoints', 'borderRadius', 'main'];